import { HTTP_REQUEST_STATUS_CODES } from "constants/constants";
import { URL_SWAGGER } from "constants/Urls";
import { axios } from "lib/axios";
import { AxiosError } from "axios";
import { baseUrl } from "./keys";

export async function checkIfInMaintenance() {
  try {
    const response = await axios.get(`${baseUrl}${URL_SWAGGER}`);
    return response.status !== HTTP_REQUEST_STATUS_CODES.OK;
  } catch (error) {
    if (error instanceof AxiosError) {
      return (
        error.response?.status === HTTP_REQUEST_STATUS_CODES.SERVER_STOPPED
      );
    }
    return false;
  }
}
